import { Flex, useColorModeValue } from "@chakra-ui/react";

export default function Field({ children, isSelected, ...rest }) {
  const bg = useColorModeValue(
    "rgba(0, 0, 0, 0.04)",
    "rgba(255, 255, 255, 0.12)"
  );
  return (
    <Flex
      width="56px"
      alignItems="center"
      justifyContent="center"
      bg={bg}
      borderRadius="12px"
      height="56px"
      {...(isSelected && { border: "3px solid", borderColor: "primary" })}
      {...rest}
    >
      {children}
    </Flex>
  );
}
